import { createFileRoute } from '@tanstack/react-router'
import { AnnouncementsPage } from '@/features/announcements'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/announcements')({
  component: () => (
    <RequirePermission permission='announcement.view'>
      <AnnouncementsPage />
    </RequirePermission>
  ),
})
